
const MyAccount = ({ width = 23, height = 24 }) => (
	<svg width={width} height={height} viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 3.5H22M1 12.5H9M14 12.5H22M17 20.5H1M3.5 6.5C4.88072 6.5 6 5.38072 6 4C6 2.61928 4.88072 1.5 3.5 1.5C2.11928 1.5 1 2.61928 1 4C1 5.38072 2.11928 6.5 3.5 6.5ZM11.5 14.5C12.8807 14.5 14 13.3807 14 12C14 10.6193 12.8807 9.5 11.5 9.5C10.1193 9.5 9 10.6193 9 12C9 13.3807 10.1193 14.5 11.5 14.5ZM19.5 22.5C20.8807 22.5 22 21.3807 22 20C22 18.6193 20.8807 17.5 19.5 17.5C18.1193 17.5 17 18.6193 17 20C17 21.3807 18.1193 22.5 19.5 22.5Z" stroke="currentColor" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export default MyAccount;
  